"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
exports.breakpoints = {
    notSmall: '(min-width: 768px)',
    medium: '(min-width: 768px) and (max-width: 1200px)',
    large: '(min-width: 1200px)',
};
//# sourceMappingURL=breakpoints.js.map